module.exports = __webpack_public_path__ + "img/nav-design-modern.dfa9d35.webp";